const Grid2ForwardIconWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="Grid2ForwardIcon"
      id="Grid2ForwardIconId"
      style={{
        width: "48px",
        height: "48px",
        background: "white",
        borderRadius: "50rem",
        padding: "0.6rem"
      }}
      fill="#000000"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <line
        x1="40"
        y1="128"
        x2="216"
        y2="128"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      ></line>
      <polyline
        points="144 56 216 128 144 200"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      ></polyline>
    </svg>
  );
};
export default Grid2ForwardIconWhite;
